<template>
  <div class="pa-6 pt-10">
    <v-data-table :headers="headers" :items="unitCategories" :search="search">
      <template #top>
        <v-toolbar flat>
          <v-toolbar-title>Categorias das Unidades de Atendimento</v-toolbar-title>
          <v-divider class="mx-4" inset vertical />

          <v-spacer />

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Procurar"
            single-line
            hide-details
          />

          <v-spacer />
          <v-btn color="primary" dark class="mb-2" @click="dialog = true"> Adicionar </v-btn>
        </v-toolbar>
      </template>
      <template #item.actions="{ item }">
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-icon small class="mr-2" v-bind="attrs" @click="editItem(item)" v-on="on">
              mdi-pencil
            </v-icon>
          </template>
          <span>Editar</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" hide-overlay fullscreen>
      <form-unit-categories
        v-if="dialog"
        :populate-with="unitCategoriesToEdit"
        @unit-category-added="addUnitsCategories"
        @unit-category-edited="editUnitsCategories"
        @close-dialog="closeDialog"
      />
    </v-dialog>
  </div>
</template>

<script>
import UnitCategoryService from "../../../services/unit-category.service";
// import DeleteConfirmation from '../../../components/shared/DeleteConfirmation';

export default {
  name: "UnitCategoriesList",
  components: {
    "form-unit-categories": () => import("./Form"),
    // DeleteConfirmation,
  },

  data: () => ({
    headers: [
      {
        text: "Nome",
        sortable: false,
        value: "title",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    search: "",
    unitCategories: [],
    dialog: false,
    unitCategoriesToEdit: {},
    // dialogDeleteConfirmation: false,
  }),

  async created() {
    try {
      const result = await UnitCategoryService.findAll();
      this.unitCategories = result;
    } catch (e) {
      this.$handleHttpError(e);
    }
  },

  methods: {
    closeDialog() {
      this.dialog = false;
      this.unitCategoriesToEdit = {};
    },

    editItem(item) {
      this.unitCategoriesToEdit = item;
      this.dialog = true;
    },

    // prepareToDelete(item) {
    //   this.dialogDeleteConfirmation = true;
    //   this.deleteItemID = item.id;
    // },

    // async deleteItem() {
    //   try {
    //     await UnitCategoryService.deleteOne(this.deleteItemID);
    //     const index = this.unitCategories.findIndex((listUnitsCategories) => listUnitsCategories.id === this.deleteItemID);
    //     this.unitCategories.splice(index, 1);
    //     this.dialogDeleteConfirmation = false;
    //     this.$toast.success('Unidade de Atendimento excluída com sucesso');
    //   } catch (e) {
    //     this.$handleHttpError(e);
    //   }
    // },

    addUnitsCategories(unitsCategories) {
      this.unitCategories.push(unitsCategories);
    },

    editUnitsCategories(unitsCategories) {
      const index = this.unitCategories.findIndex(
        (listUnitsCategories) => listUnitsCategories.id === unitsCategories.id
      );
      this.unitCategories[index] = unitsCategories;
    },
  },
};
</script>

<style scoped></style>
